import { DocumentTypesEnum } from "./DocumentTypesEnum";
export var PaymentDocumentTypes = [
    { item: DocumentTypesEnum.DNI, value: DocumentTypesEnum.DNI },
    { item: DocumentTypesEnum.CC, value: DocumentTypesEnum.CC },
    { item: DocumentTypesEnum.NIT, value: DocumentTypesEnum.NIT },
    { item: DocumentTypesEnum.CE, value: DocumentTypesEnum.CE },
    { item: DocumentTypesEnum.TI, value: DocumentTypesEnum.TI },
    { item: DocumentTypesEnum.PP, value: DocumentTypesEnum.PP },
    { item: DocumentTypesEnum.PAS, value: DocumentTypesEnum.PAS },
];
export var EcuadorianPaymentDocumentTypes = [
    { item: DocumentTypesEnum.CI, value: DocumentTypesEnum.CI },
    { item: DocumentTypesEnum.RUC, value: DocumentTypesEnum.RUC },
    { item: DocumentTypesEnum.PAS, value: DocumentTypesEnum.PAS },
];
export var ColombianPaymentDocumentTypes = [
    { item: DocumentTypesEnum.CC, value: DocumentTypesEnum.CC },
    { item: DocumentTypesEnum.NIT, value: DocumentTypesEnum.NIT },
    { item: DocumentTypesEnum.TI, value: DocumentTypesEnum.TI },
    { item: DocumentTypesEnum.PP, value: DocumentTypesEnum.PP },
];
export var PeruvianPaymentDocumentTypes = [
    { item: DocumentTypesEnum.DNI, value: DocumentTypesEnum.DNI },
    { item: DocumentTypesEnum.CE, value: DocumentTypesEnum.CE },
    { item: DocumentTypesEnum.PAS, value: DocumentTypesEnum.PAS },
    { item: DocumentTypesEnum.RUC, value: DocumentTypesEnum.RUC },
];
export var ChileanPaymentDocumentTypes = [
    { item: DocumentTypesEnum.CC, value: DocumentTypesEnum.CC },
    { item: DocumentTypesEnum.TI, value: DocumentTypesEnum.TI },
    { item: DocumentTypesEnum.PP, value: DocumentTypesEnum.PP },
    { item: DocumentTypesEnum.RUT, value: DocumentTypesEnum.RUT },
];
export var MexicanPaymentDocumentTypes = [
    { item: DocumentTypesEnum.PP, value: DocumentTypesEnum.PP },
    { item: DocumentTypesEnum.CURP, value: DocumentTypesEnum.CURP },
    { item: DocumentTypesEnum.RFC, value: DocumentTypesEnum.RFC },
];
